export const environment = {
    production: true,
    configJsonProdUrl: window['env'].CONF_JSON_PROD_URL || 'http://eksen.hvlnet.net:8888/config/public/default/framework(_)ui(_)eksen/config.json',
    configSecureJsonProdUrl: window['env'].CONF_SECURE_JSON_PROD_URL || 'http://eksen.hvlnet.net:8888/config/private/default/framework(_)ui(_)eksen(_)secure/config_secure.json',
    appBaseHref: window['env'].APP_BASE_HREF || '/',
};
